import Layout from '@/pages/Layout.vue'

import Dashboard from '@/pages/Dashboard.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsNew from '@/pages/Administrators/New.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

import Films from '@/pages/Films.vue'
import FilmsView from '@/pages/Films/View.vue'
import FilmsDetail from '@/pages/Films/Detail.vue'
import FilmsNew from '@/pages/Films/New.vue'
import FilmsEdit from '@/pages/Films/Edit.vue'

import Users from '@/pages/Users.vue'
import UsersView from '@/pages/Users/View.vue'
import UsersDetail from '@/pages/Users/Detail.vue'
import UsersNew from '@/pages/Users/New.vue'
import UsersEdit from '@/pages/Users/Edit.vue'

import Referral from '@/pages/Referral.vue'
import ReferralView from '@/pages/Referral/View.vue'
import ReferralDetail from '@/pages/Referral/Detail.vue'

import Payments from '@/pages/Payments.vue'
import PaymentsView from '@/pages/Payments/View.vue'

import Transactions from '@/pages/Transactions.vue'
import TransactionsView from '@/pages/Transactions/View.vue'

import Partners from '@/pages/Partners.vue'
import PartnersView from '@/pages/Partners/View.vue'
import PartnersEdit from '@/pages/Partners/Edit.vue'
import PartnersDetail from '@/pages/Partners/Detail.vue'

import Slideshows from '@/pages/Slideshows.vue'
import SlideshowsView from '@/pages/Slideshows/View.vue'

import Coupons from '@/pages/Coupons.vue'
import CouponsView from '@/pages/Coupons/View.vue'
import CouponsDetail from '@/pages/Coupons/Detail.vue'

import Actors from '@/pages/Actors.vue'
import ActorsView from '@/pages/Actors/View.vue'
import ActorsNew from '@/pages/Actors/New.vue'
import ActorsEdit from '@/pages/Actors/Edit.vue'

import Trailers from '@/pages/Trailers.vue'
import TrailersView from '@/pages/Trailers/View.vue'

import Notifications from '@/pages/Notifications.vue'
import NotificationsView from '@/pages/Notifications/View.vue'

import PrintPartnerPayment from '@/pages/PrintPartnerPayment.vue'

import Route404 from '@/pages/404.vue'

const routes = [
	{
		path: '/',
		component: Layout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						component: SettingsView
					},
				]
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						component: AdministratorsView
					},
					{
						path: 'new',
						component: AdministratorsNew
					},
					{
						path: 'edit/:hash',
						component: AdministratorsEdit
					},

				]
			},
			{
				path: 'partners',
				component: Partners,
				children: [
					{
						path: '',
						component: PartnersView
					},
					{
						path: 'edit/:hash',
						component: PartnersEdit
					},
					{
						path: 'detail/:hash',
						component: PartnersDetail
					},

				]
			},
			{
				path: 'users',
				component: Users,
				children: [
					{
						path: '',
						component: UsersView
					},
					{
						path: 'new',
						component: UsersNew
					},
					{
						path: 'edit/:hash',
						component: UsersEdit
					},
					{
						path: 'detail/:hash',
						component: UsersDetail
					},

				]
			},
			{
				path: 'referrals',
				component: Referral,
				children: [
					{
						path: '',
						component: ReferralView
					},
					{
						path: 'detail/:hash',
						component: ReferralDetail
					},

				]
			},
			{
				path: 'films',
				component: Films,
				children: [
					{
						path: '',
						component: FilmsView
					},
					{
						path: 'new',
						component: FilmsNew
					},
					{
						path: 'edit/:hash',
						component: FilmsEdit
					},
					{
						path: 'detail/:hash',
						component: FilmsDetail
					},

				]
			},
			{
				path: 'slideshows',
				component: Slideshows,
				children: [
					{
						path: '',
						component: SlideshowsView
					}
				]
			},
			{
				path: 'coupons',
				component: Coupons,
				children: [
					{
						path: '',
						component: CouponsView
					},
					{
						path: 'detail/:hash',
						component: CouponsDetail
					}
				]
			},
			{
				path: 'payments',
				component: Payments,
				children: [
					{
						path: '',
						component: PaymentsView
					}
				]
			},
			{
				path: 'transactions',
				component: Transactions,
				children: [
					{
						path: '',
						component: TransactionsView
					}
				]
			},
			{
				path: 'trailers',
				component: Trailers,
				children: [
					{
						path: '',
						component: TrailersView
					},
				]
			},
			{
				path: 'notifications',
				component: Notifications,
				children: [
					{
						path: '',
						component: NotificationsView
					},
				]
			},
			{
				path: 'actors',
				component: Actors,
				children: [
					{
						path: '',
						component: ActorsView
					},
					{
						path: 'new',
						component: ActorsNew
					},
					{
						path: 'edit/:hash',
						component: ActorsEdit
					}
				]
			},
		]
	},
	{
		path: '/print_partner_payment/:hash',
		name: "PrintPartnerPayment",
		component: PrintPartnerPayment,
	},
	{
		path: '*',
		component: Route404
	},

]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js